import { Controller } from "@hotwired/stimulus"

// Лайтбокс превью открытки (web-08): клик по картинке открывает её в полном
// размере поверх страницы, чтобы рассмотреть детали. Overlay живёт вне
// data-poll-target='frame', поэтому опрос статуса его не затирает.
// Закрытие — клик по фону, крестик или Esc.
export default class extends Controller {
  static targets = ["overlay", "image"]

  open(event) {
    const src = event.currentTarget.dataset.lightboxSrc || event.currentTarget.src
    if (!src) return

    this.imageTarget.src = src
    this.overlayTarget.classList.add("is-open")
    document.body.classList.add("pc-no-scroll")
  }

  // Картинка — role="button" с tabindex, поэтому открываем и с клавиатуры.
  openOnKey(event) {
    if (event.key !== "Enter" && event.key !== " ") return

    event.preventDefault()
    this.open(event)
  }

  close() {
    this.overlayTarget.classList.remove("is-open")
    document.body.classList.remove("pc-no-scroll")
    this.imageTarget.removeAttribute("src")
  }

  closeOnKey(event) {
    if (event.key === "Escape") this.close()
  }

  // Клик по самой картинке не должен закрывать лайтбокс — гасим всплытие к фону.
  stop(event) {
    event.stopPropagation()
  }
}
